<template>

</template>

<script>
  export default {
    name: 'PriceHome'
  }
</script>

<style scoped>

</style>
